
const Alert = ({ text }) => {
    return (
        <div className="text-center bg-red-200 border border-red-400 text-red-700 my-2 px-2 py-2 rounded relative w-full" role="alert">
            <span className="text-center">{text}</span>
        </div >
    )
};

export default Alert;
